<template>
    <div style="margin:10px">
        <Row style="margin-bottom: 20px">
            <Button style="float:right" shape="circle" icon="md-refresh" @click="onClickRefresh"></Button>
        </Row>

        <Row style="margin-bottom: 20px">

            <Form :model="formItem" :label-width="150">
                <FormItem label="Gnosis Safe Address">
                    <Input v-model="formItem.gnosisSafeAddr" placeholder="0x..." style="width:380px">
                    </Input>
                </FormItem>
                <FormItem label="Safe Module Address">
                    <Input v-model="formItem.safeModuleAddr" placeholder="0x..." style="width:380px">
                    </Input>
                </FormItem>
                <FormItem label="Network">
                    <Select v-model="formItem.selectNetId" style="width:150px;margin-left: 10px">
                        <Option v-for="item in chainInfoList" :value="item.id" :key="item.id">{{ item.chainName }}
                        </Option>
                    </Select>
                </FormItem>

                <FormItem label="Token">
                    <Input v-model="formItem.withdrawToken" placeholder="0x..." style="width:380px">
                    </Input>
                    <Button type="success" style="margin-left: 10px" @click="onCheckWithdrawTokenBalance()">
                        Check
                    </Button>
                </FormItem>
                <FormItem label="Amount">
                    <Input v-model="formItem.withdrawValue" placeholder="输入提币数量" style="width:380px">
                    </Input>
                    <Tag type="border" color="primary" style="margin-left: 10px" v-if="this.formItem.withdrawTokenInfo">
                        {{this.formItem.withdrawTokenInfo.symbol}}
                    </Tag>
                </FormItem>

                <FormItem>
                    <Button type="error" @click="onClickWithdraw()">
                        Withdraw
                    </Button>
                </FormItem>
            </Form>

        </Row>

    </div>
</template>

<script>
import TagList from '@/components/common/TagList'
import contract from '@/utils/contracts/common'
import { waitForTx, chainInfoMap } from '@/utils/tx'
import Store from '@/utils/store'
import tools from '@/utils/contracts/tools'

export default {
  name: 'token_transfer',
  components: {
    TagList,
  },
  data () {
    let chainInfoList = []
    for (let id in chainInfoMap) {
      let info = chainInfoMap[id]
      info.id = id
      chainInfoList.push(info)
    }
    return {
      indexAddr: '',
      formItem: {
        gnosisSafeAddr: '',
        safeModuleAddr: '',
        withdrawToken: "",
        withdrawValue: 0
      },
      chainInfoList: chainInfoList,
      netId: 1,
      myAddr: '',
      tokenList: [],
    }
  },
  async mounted () {
    this.netId = await web3.eth.net.getId()
    this.formItem = {
      gnosisSafeAddr: this.$route.query.gnosisSafeAddr,
      safeModuleAddr: this.$route.query.safeModuleAddr,
      withdrawToken: this.$route.query.withdrawToken,
      withdrawValue: 0
    }
    this.myAddr = window.currAddress
    this.$set(this.formItem, 'selectNetId', '' + this.netId)
    await this.onCheckWithdrawTokenBalance()
  },

  methods: {
    divDecimals: tools.divDecimals,
    mulDecimals: tools.mulDecimals,
    async onClickRefresh () {
      window.location.reload()
    },
    async onCheckWithdrawTokenBalance () {
      let token = await contract.getERC20Info(this.formItem.withdrawToken)
      let tokenBalance = await contract.getERC20BalanceOf(this.formItem.withdrawToken, this.formItem.gnosisSafeAddr)
      this.formItem.withdrawTokenInfo = token
      this.formItem.withdrawTokenBalance = tokenBalance
      this.formItem.withdrawValue = this.divDecimals(this.formItem.withdrawTokenBalance, this.formItem.withdrawTokenInfo.decimals).toString()
    },
    onClickWithdraw () {
      if (!this.formItem.withdrawToken || !this.formItem.withdrawValue) return
      let safe = contract.getSafe(this.formItem.safeModuleAddr)
      let value = this.mulDecimals(this.formItem.withdrawValue, this.formItem.withdrawTokenInfo.decimals)
      console.log(this.formItem.withdrawToken, value.toString())
      let data = web3.eth.abi.encodeFunctionCall({
        name: 'transfer',
        type: 'function',
        inputs: [{
            type: 'address',
            name: 'recipient'
        },{
            type: 'uint256',
            name: 'amount'
        }]
      }, [this.myAddr, value.toString()]);
      safe.methods
        .execTransaction(this.formItem.withdrawToken, data.toString())
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) {
              this.onClickRefresh()
            }
          })
        })
    },
  }
}
</script>

<style scoped>

</style>
